// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"768px","itemMargin":".3rem"};